/**
 * Shared Contentful string normalization (ForDeer app slugs, section ids, etc.).
 * Used by `@fordeer/ui-components` (banner, FAQ, whats-new, …) and consumers like the changelog app.
 */
export const normalizeContentfulValue = (value?: string): string =>
  value?.trim().toLowerCase().replace(/[^a-z0-9]/g, '') ?? ''

export const normalizeAppIdentifier = (value?: string): string =>
  normalizeContentfulValue(value).replace(/app$/, '')
